// extracted by mini-css-extract-plugin
module.exports = {"noDataView":"no-data-view_noDataView__Znyt3"};